import { render, staticRenderFns } from "./formulaModal.vue?vue&type=template&id=5daa4037"
import script from "./formulaModal.vue?vue&type=script&lang=js"
export * from "./formulaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports